
<div class="cp-material">
  <input type="text" class="name" v-model="name" />
  <input type="number" class="phone" v-model="phone" />
  <textarea class="address" rows="4" v-model="address" />
  <div v-if="showErr" class="error">{{msg}}</div>
  <div class="action" @click="handleAddress"></div>
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
